import { useEffect, useRef } from "react";

const reduced = () => typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function ParallaxImg({ speed = 0.12, className = "", style, ...p }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current; const box = el?.parentElement;
    if (!el || !box || reduced()) return;
    let raf = 0;
    const tick = () => {
      raf = 0;
      const r = box.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < -100 || r.top > vh + 100) return;
      el.style.transform = `translate3d(0, ${((r.top + r.height / 2 - vh / 2) * -speed).toFixed(1)}px, 0)`;
    };
    const on = () => { if (!raf) raf = requestAnimationFrame(tick); };
    tick(); window.addEventListener("scroll", on, { passive: true }); window.addEventListener("resize", on);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("scroll", on); window.removeEventListener("resize", on); };
  }, [speed]);
  return <img ref={ref} alt="" {...p} className={`cine-img ${className}`} style={{ willChange: "transform", ...style }} />;
}

export const CineBanner = ({ src, children, className = "", testid, priority }) => (
  <section className={`cine relative overflow-hidden text-white bg-black ${className}`} data-testid={testid}>
    <div className="cine-in absolute inset-0"><ParallaxImg src={src} {...(priority ? { fetchPriority: "high" } : { loading: "lazy" })} className="absolute left-0 w-full object-cover opacity-80" style={{ top: "-9%", height: "118%" }} /></div>
    <div className="cine-shade absolute inset-0" /><div className="cine-gold absolute inset-x-0 bottom-0" />
    {children}
  </section>
);
